import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../navbar';
import TopNavbar from '../topnavbar';
import Footer from '../footer';
import '../../App.css';
import { base64pdf } from '../../vblob';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import "react-pdf/dist/esm/Page/TextLayer.css"; 

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { Document, Page, pdfjs } from 'react-pdf'; 

function RequestView() {
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`; 

    const location = useLocation();
    const navigate = useNavigate();
    const data = location.state.data;
    const [showModal, setShowModal] = useState(false);
    const [numPages, setNumPages] = useState();
    const [pdfUrl, setPdfUrl] = useState(''); 
    const [imageUrl, setImageUrl] = useState('');
    const [fileName, setFileName] = useState('');
    
    const [pdf, setPdf] = useState([]);
    const [resubmitFiles, setResubmitFiles] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleResubmitPDF = (e, requirementName, PdfFileID) => {
        const thisSubmissionID = data.SubmissionID;
        const fileWithRequirementName = { file: e.target.files[0], requirementName, PdfFileID, thisSubmissionID};
        setResubmitFiles([...resubmitFiles, fileWithRequirementName]);
    };
    
    const convertToPDF = (base64) => { 
        const binaryString = atob(base64?base64:base64pdf.blobpdf2);
        const arrayBuffer = new ArrayBuffer(binaryString.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryString.length; i++) {
            uint8Array[i] = binaryString.charCodeAt(i);
        } 
        const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        setPdfUrl(url);
        return url;
    } 
    
    const convertToImage = (base64, type) => {
        const binaryString = atob(base64);
        const arrayBuffer = new ArrayBuffer(binaryString.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryString.length; i++) {
            uint8Array[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([arrayBuffer], { type: `image/${type}` });
        return URL.createObjectURL(blob);
    };

    const convertAndDownloadPDF = (base64, fileName) => {  
        const url = convertToPDF(base64);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    };
  
    useEffect(() => { 
        getSubmissionPDF();
    }, []); 
 
    const getSubmissionPDF = async () => {
        const formData = new FormData();
        formData.append('SubmissionID', data.SubmissionID);
        
        try {
            const uploadResponse = await fetch('/api/submissionpdf', {
                method: 'POST',
                body: formData,
            });
        
            if (!uploadResponse.ok) {
                console.error('Failed to upload PDF:', uploadResponse.statusText);
                return;
            }

            try {
                const responseData = await uploadResponse.json();
                const sortedData = responseData.result.sort((a, b) => { 
                    if (a.RequirementName !== b.RequirementName) {
                        return a.RequirementName.localeCompare(b.RequirementName);
                    } else { 
                        return b.Updated - a.Updated;
                    }
                }); 
                
                setPdf(sortedData);
                
            } catch (error) {
                console.error('Error parsing JSON response:', error);
            }
        
        } catch (error) {
            console.error('Error uploading PDF:', error);
        }
    }; 

    const handleFormSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Find all items that require resubmission
    const requiredResubmits = pdf.filter(
        item => item.Resubmit === 1 && item.EmpResubmitted === 0
    );

    // Ensure each requirement has an uploaded file
    const missingUploads = requiredResubmits.filter(req =>
        !resubmitFiles.some(file => file.PdfFileID === req.PdfFileID)
    );

    if (missingUploads.length > 0) {
        toast.warn("Please upload all required files before submitting.", {
            position: "top-right",
            autoClose: 5000
        });
        setIsSubmitting(false);
        return;
    }

    // No missing uploads → continue
    const formData = new FormData();
    resubmitFiles.forEach((file) => {
        formData.append('newPDF', file.file);
        formData.append('requirementName', file.requirementName.toString());
        formData.append('PdfFileID', file.PdfFileID);
        formData.append('SubmissionID', parseInt(file.thisSubmissionID));
    });

    try {
        const response = await fetch('/api/resubmitPDF', {
            method: 'POST',
            body: formData
        });

        if (response.ok) {
            toast.success('Submitted Successfully', {
                position: "top-right",
                autoClose: 2000
            });
            setIsSubmitting(false);
            setResubmitFiles([]);
            setTimeout(() => navigate("/submissions"), 800);
        } else {
            toast.error('Failed to Submit', {
                position: "top-right",
                autoClose: 5000
            });
            setIsSubmitting(false);
        }
    } catch (error) {
        console.error('Error uploading PDF:', error);
        setIsSubmitting(false);
    }
};

    
    const handleButtonClick = (data) => {
        setFileName(data.FileName || "File");
        setPdfUrl('');
        setImageUrl('');

        const fileName = (data.FileName || '').toLowerCase();
        const contentType = (data.ContentType || '').toLowerCase();
        const isPdf = fileName.endsWith('.pdf') || contentType.includes('pdf');

        if (isPdf) {
            convertToPDF(data.PdfData);
        } else {
            let imageType = 'jpeg';
            if (contentType.includes('png') || fileName.endsWith('.png')) imageType = 'png';
            else if (contentType.includes('gif') || fileName.endsWith('.gif')) imageType = 'gif';
            else if (contentType.includes('webp') || fileName.endsWith('.webp')) imageType = 'webp';

            setImageUrl(convertToImage(data.PdfData, imageType));
        }
        setShowModal(true);
    };

    const handleCloseModal = () => setShowModal(false);

    const handleCancel = async () => {
        const thisAction = "Cancelled"; 
        const formData = new FormData();
        formData.append('thisAction', thisAction);
        formData.append('thisSubmissionID', data.SubmissionID);

        try {
            const response = await fetch('/api/UpdateRequest', { method: 'POST', body: formData }); 
            if (response.ok) {
                toast.success('Submitted Successfully', { position: "top-right", autoClose: 2000 });
                setTimeout(() => {
                  window.history.back();
                }, 3000);
            } else {
                toast.error('Failed to Submit', { position: "top-right", autoClose: 5000 });
            } 
        } catch (error) {
            console.error('Error updating failed:', error);
        }
    };

/*
    const validate = () => { 
        return !!(
            data.LoanAppDate || data.TransactionNum || data.TypeOfDelivery || 
            data.CorrectName || data.DeductionFor || data.Description || 
            data.ErroneousName || data.OtherReq || data.ReasonType || 
            data.RequestTitle || data.RequestType || data.PlaceOfConfinement || 
            data.BankAccNumber || data.CompletionDate || data.ReasonForInfoUpdate || 
            data.CurrentFullname || data.NewFullname || 
            data.CurrentCivilStatus || data.NewCivilStatus
        );
    };
*/
 
    return (
        <div id="wrapper">
            <Navbar />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopNavbar />
                    <div className="container-fluid">
                        <div className="row justify-content-center">
                            <h4 className="m-0 font-weight-bold text-primary header-name">{data.TransactionType}</h4>
                        </div>
                        <br/>

                        {/* ROW FIXED: LEFT + RIGHT COLUMN */}
                        <div className="row justify-content-center">
                            {/* LEFT COLUMN */}
                            <div className="col-md-4">
                                <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        <h6 className="m-0 font-weight-bold text-primary">Request Details</h6>
                                    </div>
                                    <br/>
                                    <div className="tab-content">
                                        <div className="tab-pane fade show active" id="personalDetails" role="tabpanel">
                                            <div style={{ marginRight: '40px', marginLeft: '20px', marginBottom: '20px' }}>
                                                {data.DeductionFor && <p className='mb-0'><b className='text-success'>Stop Deduction For:</b> {data.DeductionFor}</p>}
                                                {data.RequestTitle && <p className='mb-0'><b className='text-success'>Request Title:</b> {data.RequestTitle}</p>}
                                                {data.Description && (
                                                 <p className='mb-0'>
                                                   <b className='text-success'> {data.RequestType == 'Certificate Request (PHILHEALTH)' ? "Reason" : "Description"}:</b> {data.Description}
                                                 </p>
                                                )}
                                                {data.ErroneousName && <p className='mb-0'><b className='text-success'>Erroneous Name:</b> {data.ErroneousName}</p>}
                                                {data.LoanAppDate && <p className='mb-0'><b className='text-success'>Loan Application Date:</b> {data.LoanAppDate}</p>}
                                                {data.OtherReq && <p className='mb-0'><b className='text-success'>Other Request:</b> {data.OtherReq}</p>}
                                                {data.ReasonType && <p className='mb-0'><b className='text-success'>Reason Type:</b> {data.ReasonType}</p>}
                                                {data.RequestType && <p className='mb-0'><b className='text-success'>Request Type:</b> {data.RequestType}</p>}
                                                {data.TransactionNum && <p className='mb-0'><b className='text-success'>Transaction Number:</b> {data.TransactionNum}</p>}
                                                {data.TypeOfDelivery && <p className='mb-0'><b className='text-success'>Type of Delivery:</b> {data.TypeOfDelivery}</p>}
                                                {data.PlaceOfConfinement && <p className='mb-0'><b className='text-success'>Place of Confinement:</b> {data.PlaceOfConfinement}</p>}
                                                {data.BankAccNumber && <p className='mb-0'><b className='text-success'>Bank Account Number:</b> {data.BankAccNumber}</p>}
                                                {data.CompletionDate && <p className='mb-0'><b className='text-success'>Completion Date:</b> {data.CompletionDate}</p>}
                                                {data.ReasonForInfoUpdate && <p className='mb-0'><b className='text-success'>Reason For Information Update:</b> {data.ReasonForInfoUpdate}</p>}
                                                {data.CurrentFullname && <p className='mb-0'><b className='text-success'>Current Full Name:</b> {data.CurrentFullname}</p>}
                                                {data.NewFullname && <p className='mb-0'><b className='text-success'>New Full Name:</b> {data.NewFullname}</p>}
                                                {data.CurrentCivilStatus && <p className='mb-0'><b className='text-success'>Current Civil Status:</b> {data.CurrentCivilStatus}</p>}
                                                {data.NewCivilStatus && <p className='mb-0'><b className='text-success'>New Civil Status:</b> {data.NewCivilStatus}</p>}

                                                <p className='mb-0'><b className='text-success'>Date Submitted:</b> {data.DateTime}</p>
                                                <p className='mb-0'><b className='text-success'>Turn Around:</b> {data.TurnAround}</p>
                                                <p className='mb-0'><b className='text-success'>Status:</b> {data.Status}</p>

                                                {data.Status === 'Pending' && (
                                                    <Button style={{ marginTop: '20px' }} type="button" onClick={handleCancel}>
                                                        Cancel
                                                    </Button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                  {data.GrossIncome || data.NetIncome ?
                                  <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        <h6 className="m-0 font-weight-bold text-primary">Income Details</h6>
                                    </div>
                                    <br/>
                                    <div className="tab-content">
                                        <div className="tab-pane fade show active" id="personalDetails" role="tabpanel">
                                            <div style={{ marginRight: '40px', marginLeft: '20px', marginBottom: '20px' }}>
                                               {data.GrossIncome && (
                                                  <p className="mb-0">
                                                    <b className="text-success">Gross Income:</b>{" "}
                                                    {Number(data.GrossIncome).toLocaleString()}
                                                  </p>
                                                )}

                                                {data.NetIncome && (
                                                  <p className="mb-0">
                                                    <b className="text-success">Net Income:</b>{" "}
                                                    {Number(data.NetIncome).toLocaleString()}
                                                  </p>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :''}
                            </div>

                            {/* RIGHT COLUMN */}
                            <div className='col-md-6'>
                                {pdf && pdf.map((pdfItem, index) => (
                                    <div className="card shadow mb-4" key={index}>
                                        <div className="row justify-content-center">
                                            <div className="col-md-12">
                                                <div className="card shadow">
                                                    <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                                        <h6 className="m-0 font-weight-bold text-primary">{pdfItem.RequirementName}</h6>
                                                        <h6 className="m-0 font-weight-bold" style={{ color: 'red' }}>
                                                            {pdfItem.Resubmit ? 'Resubmit' : ''}
                                                        </h6>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div>
                                                                <p className='mb-0'><b className='text-success'>Document:</b> {pdfItem.FileName}</p>
                                                                <p className='mb-0'><b className='text-success'>Date Submitted:</b> {pdfItem.UploadDate}</p>
                                                                {pdfItem.ResubmitReason?.trim() !== "" && (
                                                                  <p className="mb-3 mt-5">
                                                                    <b className="text-error">Reason:</b> {pdfItem.ResubmitReason}
                                                                  </p>
                                                                )}
                                                            </div>
                                                            <div className="col-md-4 text-center">
                                                                <button className="btn btn-danger btn-sm mr-2" onClick={() => handleButtonClick(pdfItem)}>
                                                                    View
                                                                </button>
                                                                <button className="btn btn-sm btn-primary" onClick={() => convertAndDownloadPDF(pdfItem.PdfData, pdfItem.FileName)}>
                                                                    Download
                                                                </button>
                                                            </div>
                                                        </div>
                                                        {pdfItem.Resubmit === 1 && pdfItem.EmpResubmitted === 0 && (
                                                            <div className="d-flex justify-content-left mt-3">
                                                                <input type="file" className="input-file" onChange={(e) => handleResubmitPDF(e, pdfItem.RequirementName, pdfItem.PdfFileID)} />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                {(data.BankAccountNumber || data.BankName || data.BankAccount) && (
                  <div className="card shadow mb-4">
                    <div className="card-header py-3">
                      <h6 className="m-0 font-weight-bold text-primary">Bank Details</h6>
                    </div>
                    <div className="card-body">
                       {data.BankAccountName && (
                        <div className="form-group">
                          <label className="text-success font-weight-bold">Bank Account Name:</label>
                          <input 
                            type="text" 
                            className="form-control" 
                            value={data.BankAccountName} 
                            readOnly 
                          />
                        </div>
                      )}
                       {data.BankName && (
                        <div className="form-group">
                          <label className="text-success font-weight-bold">Bank Name:</label>
                          <input 
                            type="text" 
                            className="form-control" 
                            value={data.BankName} 
                            readOnly 
                          />
                        </div>
                      )}
                      {data.BankAccountNumber && (
                        <div className="form-group">
                          <label className="text-success font-weight-bold">Bank Account Number:</label>
                          <input 
                            type="text" 
                            className="form-control" 
                            value={data.BankAccountNumber} 
                            readOnly 
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
                <br />

                                {data.Status === 'Resubmit' && (
                                 <div className="d-flex justify-content-end mt-3">
                                  <button
                                  type="submit"
                                  onClick={handleFormSubmit}
                                  className="btn btn-primary d-block mb-4"
                                  disabled={isSubmitting}
                                >
                                 {isSubmitting ? 'Resubmitting...' : 'Resubmit'}
                                </button>
                                </div>
                               )}

                            </div>
                        </div>
                        
                        {/* MODAL */}
                        <Modal show={showModal} onHide={handleCloseModal} size="lg" centered scrollable>
                          <Modal.Header>
                            <Modal.Title>{fileName}</Modal.Title>
                          </Modal.Header>

                          <Modal.Body
                           style={{
                           backgroundColor: 'lightgray',
                           maxHeight: '80vh',
                           overflowY: 'auto',
                          }}
                          >
                         {pdfUrl && (
                          <Document
                           file={pdfUrl}
                           onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                          >
        {Array.from({ length: numPages }, (_, i) => i + 1).map((page) => (
          <div style={{ marginBottom: '20px' }} key={page}>
            <Page
              pageNumber={page}
              renderAnnotationLayer={false}
              renderTextLayer={false}
            />
          </div>
        ))}
      </Document>
    )}

    {imageUrl && (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img
          src={imageUrl}
          alt="Converted Image"
          style={{
            maxWidth: '100%',
            maxHeight: '75vh',
            objectFit: 'contain',
            borderRadius: '4px',
            boxShadow: '0 0 5px rgba(0,0,0,0.2)',
          }}
        />
      </div>
    )}
  </Modal.Body>

  <Modal.Footer>
    <button
      type="button"
      className="btnClose btn btn-secondary btn-sm"
      onClick={handleCloseModal}
    >
      Close
    </button>
  </Modal.Footer>
</Modal>

                    </div>

                    <Footer />
                </div>

                <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" />
            </div>
        </div>
    );
}

export default RequestView;
